<template>
  <settings-page />
</template>

<script>
import SettingsPage from "../components/SettingsPageNew.vue";

export default {
  components: {
    SettingsPage,
  },
};
</script>

<style></style>